import React from 'react';
import { Button } from './ui/Button';
interface BeforeAfterSectionProps {
  onOpenModal: () => void;
}
export function BeforeAfterSection({
  onOpenModal
}: BeforeAfterSectionProps) {
  return <section className="py-20 md:py-32 bg-brand-alt" data-id="element-1">
      <div className="container px-4 md:px-6" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-brand-text mb-6" data-id="element-4">
            Real Results
          </h2>
          <p className="font-sans text-brand-text/70 max-w-2xl mx-auto" data-id="element-5">
            Actual Be Clinical patients. Unretouched photos showing the
            regenerative power of BBL Forever Young.
          </p>
        </div>

        <div className="max-w-6xl mx-auto" data-id="element-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-7">
            {/* Result 1 */}
            <div className="rounded-sm overflow-hidden" data-id="element-8">
              <img src="https://cdn.magicpatterns.com/uploads/ukeHDF8SnoiHRD2uDF6oJc/63325655-0-halo-before-after-2.webp" alt="BBL Forever Young before and after results - pigmentation reduction" className="w-full h-auto" data-id="element-9" />
            </div>

            {/* Result 2 */}
            <div className="rounded-sm overflow-hidden" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/ciLtWG4RisJHZsXCb9kwBm/63325656-0-halo-before-after-5.webp" alt="BBL Forever Young before and after results - sun damage treatment" className="w-full h-auto" data-id="element-11" />
            </div>

            {/* Result 3 */}
            <div className="rounded-sm overflow-hidden" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/84HniF4bRP8jtFyHwcRHow/63325968-0-IMG-5655.webp" alt="BBL Forever Young before and after results - age spot removal" className="w-full h-auto" data-id="element-13" />
            </div>

            {/* Result 4 */}
            <div className="rounded-sm overflow-hidden" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/6DEpSpDQBtPEks6JRLWqtY/63325654-0-halo-before-after-1.webp" alt="BBL Forever Young before and after results - skin tone improvement" className="w-full h-auto" data-id="element-15" />
            </div>

            {/* Result 5 */}
            <div className="rounded-sm overflow-hidden md:col-span-2" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/ewNL4vwjdogR8R5fPvC6ZQ/bbl3.png" alt="BBL Hero before, immediately post, and after treatment results" className="w-full h-auto" data-id="element-17" />
            </div>

            {/* Result 6 */}
            <div className="rounded-sm overflow-hidden" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/fURqGH981i3HiFb1kczXnk/BBL_before_and_after0.jpg" alt="BBL before and after results - freckle and sun spot reduction" className="w-full h-auto" data-id="element-19" />
            </div>

            {/* Result 7 */}
            <div className="rounded-sm overflow-hidden" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/bkGsZngZZKtdafeY5mPTh2/bbl2.jpg" alt="BBL before and after results - facial pigmentation improvement" className="w-full h-auto" data-id="element-21" />
            </div>

            {/* Result 8 */}
            <div className="rounded-sm overflow-hidden md:col-span-2" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/jZaknNwJvXf3QG2kLjJLF6/bbl.1.jpg" alt="BBL before and after results - hand rejuvenation" className="w-full h-auto" data-id="element-23" />
            </div>
          </div>

          <div className="text-center border-t border-brand-divider pt-8" data-id="element-24">
            <p className="font-sans text-brand-text/80 italic" data-id="element-25">
              "My sun spots are completely gone and my skin has this natural
              glow I haven't seen in years."
            </p>
            <p className="font-sans text-sm text-brand-text/60 mt-2 uppercase tracking-wider mb-8" data-id="element-26">
              — Patient, 42, San Ramon CA
            </p>
            <Button onClick={onOpenModal} data-id="element-27">Book A Consultation</Button>
          </div>
        </div>
      </div>
    </section>;
}